import React from 'react';
import { Box, Button } from '@mui/material';

const Cell = ({ mark, highlighted, locked, onPlay, label }) => {
    const face = {
        borderColor: highlighted ? 'secondary.main' : 'divider',
        bgcolor: highlighted ? 'secondary.main' : 'background.paper',
        color: highlighted ? 'secondary.contrastText' : 'text.primary',
    };

    return (
        <Button
            onClick={onPlay}
            disabled={locked}
            aria-label={label}
            sx={{
                minWidth: 0,
                aspectRatio: '1 / 1',
                fontSize: { xs: '2.25rem', sm: '2.75rem' },
                fontWeight: 800,
                lineHeight: 1,
                border: '2px solid',
                ...face,
                // MUI greys a disabled label out, which would fade the very
                // marks the board exists to show.
                '&.Mui-disabled': face,
            }}
        >
            {mark}
        </Button>
    );
};

const Board = ({ cells, playable, winningLine, onCellClick }) => (
    <Box sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(3, 1fr)',
        gap: 1,
        width: '100%',
        maxWidth: 320,
        mx: 'auto',
    }}>
        {cells.map((mark, cell) => (
            <Cell
                key={cell}
                mark={mark}
                highlighted={winningLine?.includes(cell)}
                locked={!playable.includes(cell)}
                onPlay={() => onCellClick(cell)}
                label={`Cell ${cell + 1}, ${mark ?? 'empty'}`}
            />
        ))}
    </Box>
);

export default Board;
